<template>
  <div id="login" class="sign">
    <div class="inner">
      <h3 class="tit">SIGN IN</h3>
      <div class="form-wrap">
        <ul class="btn-wrap fw">
          <li><a :href="kakaoOauth2Url" class="btn-kakao"><i class="ico-kakao"></i>카카오로 시작</a></li>
          <li><a href="#" class="btn-email"><i class="ico-email"></i>문의하기</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {API_URL} from "@/env";

export default {
  name: "Algorithms",
  components: {},
  computed: {
    kakaoOauth2Url() {
      return API_URL + '/oauth2/authorize/kakao'
    }
  }
}
</script>

<style>
@import '~@/assets/css/main.css';
@import '~@/assets/css/reset.css';
@import '~@/assets/css/content.css';
@import '~@/assets/css/main.css';
</style>

